import { ResetPassword } from '../components/presentations/resetPassword'

 const ResetPasswordContainer = () => {
  return <ResetPassword />
}
export default ResetPasswordContainer
